import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-478c5b0d")

_pushScopeId("data-v-478c5b0d")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "pen-title" }, [
  /*#__PURE__*/_createVNode("h1", null, "Love Light Lab")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card" }, null, -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "手机号登录", -1)
const _hoisted_5 = { ref: "form" }
const _hoisted_6 = { class: "input-container" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { for: "login_username" }, "手机号", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "bar" }, null, -1)
const _hoisted_9 = { class: "input-container" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "login_password" }, "密码", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "bar" }, null, -1)
const _hoisted_12 = { class: "button-container" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "登录", -1)
const _hoisted_14 = { class: "flex-center align-center " }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("a", { href: "#" }, "忘记密码?")
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { id: "login_container" }, null, -1)
const _hoisted_17 = { class: "card alt" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("注册 ")
const _hoisted_20 = {
  style: {"visibility":"visible","position":"relative","left":"80px"},
  id: "register_container"
}
const _hoisted_21 = { class: "input-container" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { for: "reg_username" }, "手机号", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "bar" }, null, -1)
const _hoisted_24 = { class: "input-container" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { for: "reg_password" }, "密码", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "bar" }, null, -1)
const _hoisted_27 = { class: "input-container" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { for: "reg_confirm_password" }, "确认密码", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "bar" }, null, -1)
const _hoisted_30 = { class: "button-container" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, "注册", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("span", null, "返回登录", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")
  const _component_el_popover = _resolveComponent("el-popover")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", {
      class: ["container", {active: _ctx.showRegister}]
    }, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("form", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _withDirectives(_createVNode("input", {
              id: "login_username",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.username = $event)),
              required: "required"
            }, null, 512), [
              [_vModelText, _ctx.username]
            ]),
            _hoisted_7,
            _hoisted_8
          ]),
          _createVNode("div", _hoisted_9, [
            _withDirectives(_createVNode("input", {
              type: "password",
              id: "login_password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
              required: "required"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ]),
            _hoisted_10,
            _hoisted_11
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("button", {
              type: "button",
              class: { active: !!_ctx.username && !!_ctx.password },
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
            }, [
              _hoisted_13
            ], 2)
          ]),
          _createVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_el_popover, {
              placement: "right",
              width: 300,
              trigger: "hover"
            }, {
              reference: _withId(() => [
                _createVNode(_component_el_avatar, {
                  class: "wechat-icon",
                  size: "small",
                  src: require('../assets/微信.svg')
                }, null, 8, ["src"])
              ]),
              default: _withId(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ])
        ], 512)
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", {
          class: "toggle",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showRegister=true))
        }),
        _createVNode("h1", _hoisted_18, [
          _hoisted_19,
          _withDirectives(_createVNode("div", {
            class: "close",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showRegister=false))
          }, null, 512), [
            [_vShow, _ctx.$route.name !== 'Register']
          ])
        ]),
        _createVNode("form", null, [
          _withDirectives(_createVNode("div", _hoisted_20, null, 512), [
            [_vShow, !_ctx.user && _ctx.showRegister]
          ]),
          _withDirectives(_createVNode("div", null, [
            _createVNode("div", _hoisted_21, [
              _withDirectives(_createVNode("input", {
                id: "reg_username",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.username = $event)),
                required: "required"
              }, null, 512), [
                [_vModelText, _ctx.username]
              ]),
              _hoisted_22,
              _hoisted_23
            ]),
            _createVNode("div", _hoisted_24, [
              _withDirectives(_createVNode("input", {
                type: "password",
                id: "reg_password",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.password = $event)),
                required: "required"
              }, null, 512), [
                [_vModelText, _ctx.password]
              ]),
              _hoisted_25,
              _hoisted_26
            ]),
            _createVNode("div", _hoisted_27, [
              _withDirectives(_createVNode("input", {
                type: "password",
                id: "reg_confirm_password",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.confirmPassword = $event)),
                required: "required"
              }, null, 512), [
                [_vModelText, _ctx.confirmPassword]
              ]),
              _hoisted_28,
              _hoisted_29
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode("button", {
                type: "button",
                class: { active: !!_ctx.username && !!_ctx.password && !!_ctx.confirmPassword },
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)))
              }, [
                _hoisted_31
              ], 2),
              _createVNode("button", {
                class: "return-button",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, [
                _hoisted_32
              ])
            ])
          ], 512), [
            [_vShow, _ctx.user && _ctx.showRegister]
          ])
        ])
      ])
    ], 2)
  ], 64))
})